import { memoizeFunction } from '@fluentui/react/lib/Utilities';
import { ActionHubStyles } from './ActionHub.Props';
import { getTheme, getFocusStyle } from '@fluentui/react/lib/Styling';
import { CoauthorGalleryPalette } from '../Styles';
import {
  commonHighContrastOutlineHoverFocus,
  commonHighContrastHoverFocusStyles,
  baseFabricFocusAfterSelector,
} from '@ms/acui-common/lib/styling';
import { shouldUse2PixelFocusBorder } from '@ms/acui-common/lib/experiments';

export const getActionHubStyle = memoizeFunction(
  (palette: CoauthorGalleryPalette, needsBottomBorder?: boolean): ActionHubStyles => {
    return {
      button: {
        root: {
          backgroundColor: palette.itemBackgroundColor,
          width: '100%',
          paddingLeft: 12,
          paddingRight: 12,
          minHeight: palette.actionButtonHeight,
          height: 'auto',
          maxHeight: 'none',
          display: 'block',
          maxWidth: palette.maxCalloutWidth,
          minWidth: palette.minCalloutWidth,
          border: 'none',
          boxSizing: 'border-box',
          ...getFocusStyle(
            getTheme(),
            0,
            'relative',
            undefined /** highContrastStyle */,
            'transparent',
            palette.focusOutlineColor
          ),
        },
        rootHovered: { backgroundColor: palette.itemBackgroundHoverFocusColor },
        rootFocused: [
          { backgroundColor: palette.itemBackgroundHoverFocusColor },
          commonHighContrastOutlineHoverFocus,
          commonHighContrastHoverFocusStyles,
          ...(shouldUse2PixelFocusBorder()
            ? [
                {
                  [baseFabricFocusAfterSelector]: {
                    outlineWidth: 2,
                    left: 2,
                    right: 2,
                    top: 2,
                    bottom: 2,
                  },
                },
              ]
            : []),
        ],
        rootPressed: {
          backgroundColor: palette.itemBackgroundPressedColor,
        },
        flexContainer: { float: 'left' },
        label: {
          font: 'ms-fontSize-Body14',
          fontSize: palette.primaryTextSize,
          fontWeight: 400,
          margin: 0,
        },
        textContainer: { textAlign: 'left' },
      },
      persona: {
        root: {
          height: 50,
          minWidth: palette.minCalloutWidth,
          maxWidth: palette.maxCalloutWidth,
          borderBottom: needsBottomBorder ? `1px solid ${palette.borderColor}` : '',
          padding: '0px 4px 0px 4px',
          margin: '0px 8px 1px 8px',
          boxSizing: 'border-box',
        },
        primaryText: { fontWeight: 600 },
        details: { minWidth: 100, paddingLeft: 8, paddingRight: 0 },
      },
    };
  }
);
